import integerWithThousandSeparator from '../integerWithThousandSeparator';

const separators = {
  it: '.',
  fr: ' ',
  en: ',',
  de: '.',
};

const currencies = {
  it: '€',
  fr: '€',
  en: '£',
  de: '€',
};

/**
  * @desc Format currency value applying thousands separator according to language
  *
  * @param {number} value orginal number
  * @param {string} currency currency symbol/string
  * @param {lang} lang locale language
  * @param {number} currencyPos currency symbol/string position (before/after value)
  *
  * @returns {object} object { [originalObjectKey]: originalObjectKey }
*/

const formatLocalCurrency = (value, lang = 'it', opts = {}) => {
  const { currencyPos, withCurrency = true } = opts;
  const sep = separators[lang] || '.';
  const curr = currencies[lang] || '';
  const res = integerWithThousandSeparator(parseFloat(value), sep);
  if (!withCurrency) return res;
  return (!currencyPos ? `${curr} ${res}` : `${res} ${curr}`).trim();
};

export default formatLocalCurrency;
